
import React from 'react';
import ZooKudosButton from "./ZooKudosButton";
import ZooTabs from "./ZooTabs";

export default class ZooUserPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = { selected: this.props.selected || this.props.tabs[0] };
	}
	render() {
		let { user, children, onSelectTab, usersettings, tabs, selected, rightsides } = this.props;

		return (
			<div className="ZooUserPage ZooGeneralPage"> 
				<div className="ZooUserPageBanner" style={ usersettings.banner ? {backgroundImage: "url(" + usersettings.banner + ")"} : {}}>
					<div className="ZooUserPageBannerAvatar"><img alt="user avatar" src={user.avatar || "/images/default_avatar.png"} /></div>
{/*					<div className="ZooUserPageHeaderPlanIcon" title={user.plan}><FontAwesomeIcon icon={PLANS[user.plan].icon} /></div> */}
					<div className="ZooUserPageHeader">
						<h1>
							<span className="ZooUserPageUserName">{user.uri}</span> 
							<ZooKudosButton user={user} />
							<span className="ZooUserPageUserPlan">{user.plan}</span> 
						</h1>
						<h1>
							<span className="ZooUserPageTagline">{user.tagline}</span>
						</h1>
					</div>
					<div className="ZooUserPageTabs">
						<ZooTabs tabs={tabs} onSelectTab={onSelectTab} selected={selected} rightsides={rightsides} />
					</div>
				</div>
				<div className="ZooUserPageContent ClearFix">
					{children}
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/ZooUserPage.js